import {
  GENERATE_CONTENT_REPORT,
  GENERATE_SMS_USERS_REPORT,
  GENERATE_USER_REPORT,
  LOAD_GENERATE_CONTENT_REPORT,
  LOAD_GENERATE_USER_REPORT,
  LOAD_SMS_USERS_REPORT
} from '../Actions/GenerateReport'

const initialState = {
  status: 'SUCCESS'
}

/**
  * GenerateReportReducer
  * @desc Generate Report reducer handler for status of content and user report generation
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated state
*/
export default function GenerateReportReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case GENERATE_CONTENT_REPORT:
      return Object.assign({}, state, { status: state.status })
    case GENERATE_USER_REPORT:
      return Object.assign({}, state, { status: state.status })
    case LOAD_GENERATE_CONTENT_REPORT:
      return Object.assign({}, state, { status: state.status })
    case LOAD_GENERATE_USER_REPORT:
      // const status = action.data && action.data.generateUserAnalyticsCSV ? 'SUCCESS' : 'ERROR'
      // return Object.assign({}, state, { status })
      return Object.assign({}, state, { status: state.status })
    case GENERATE_SMS_USERS_REPORT:
      return Object.assign({}, state, { status: state.status })
    case LOAD_SMS_USERS_REPORT:
      return Object.assign({}, state, { status: state.status })
    default:
      return state
  }
}
